import styled from 'styled-components'

export const OrderedList = styled.ol`
	display: flex;
	flex-direction: column;
	margin: 0;
	padding: 0;
	list-style-type: none;
`
